import AxiosClient from "../../../services/axios.services";

class CoursesFunServices {
  getCourseFun = (params) =>
    AxiosClient.get(
      "/api/app/carrera_cursos_funcion/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
    
    getCourseFunByID = (id) =>
      AxiosClient.get(
        `/api/app/carrera_cursos_funcion/${id}/`,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

    getCourse = (params) =>
      AxiosClient.get(
        "/api/app/carrera_cursos/",
        {
          headers: { "Content-Type": "application/json" },
          params: params,
        }
      );
  
    getCourseByID = (id) =>
      AxiosClient.get(
        `/api/app/carrera_cursos/${id}/`,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

    getTasks = (params, iType) =>
      AxiosClient.get(
        iType === 1
          ? `/api/app/Funcional_Funciones/`
          :`/api/app/Formal_Funciones/`,
        {
          headers: { "Content-Type": "application/json" },
          params: params,
        }
      );
      
    getTasksById = (params, iType, id) =>
      AxiosClient.get(
        iType === 1
        ? 
        `/api/app/Funcional_Funciones/${id}/`:`/api/app/Formal_Funciones/${id}/`,
        {
          headers: { "Content-Type": "application/json" },
          params: params,
        },
    
      );


      editCourseFun = (id, data) =>
        AxiosClient.put(
          `/api/app/carrera_cursos_funcion/${id}/`,
          data,
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        saveCourseFun = (data) =>
          AxiosClient.post(
            "/api/app/carrera_cursos_funcion/",
            data,
            {
              headers: { "Content-Type": "application/json" },
              
            },

          );
          deleteCourseFun = (id) =>
            AxiosClient.delete(
              `/api/app/carrera_cursos_funcion/${id}/`,
              {
                headers: { "Content-Type": "application/json" },
              }
            );

}

export default new CoursesFunServices();
